import { render, staticRenderFns } from "./MitPeopleNameSearch.vue?vue&type=template&id=2e81f487&scoped=true"
import script from "./MitPeopleNameSearch.vue?vue&type=script&lang=js"
export * from "./MitPeopleNameSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81f487",
  null
  
)

export default component.exports